module.exports = __webpack_public_path__ + "img/facebook-group.5082d941.svg";